import { useMutation } from "react-query";
import { botLocalAxios, botSecureAxios } from "./bot";
import { useItems, useItemsFine } from "./app/items";
import { result } from "lodash";
import { queryClient } from "../_helpers/query";

export const useTokens = (selected_org_id) => {
    return useItemsFine(
        `qdb_token_plan`,
        `filter[organizations][_eq]=${selected_org_id}`,
        !!selected_org_id
    );
};

export const useTokenInit = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/finance/init_token`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                queryClient.invalidateQueries(["items", "qdb_token_plan"]);
            },
        }
    );
};

export const useBusiness = (
    endpoint,
    onSuccess,
    oneDone = () => {},
    extra_invalidate = null,
    onError = () => {}
) => {
    return useMutation(
        (requestdata) => {
            return (
                botSecureAxios
                    // return botLocalAxios
                    .post(`/${endpoint}`, requestdata)
                    .then((res) => {
                        return res?.data;
                    })
            );
        },
        {
            onSuccess: (data) => {
                onSuccess(data);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                    queryClient.invalidateQueries([
                        "items",
                        "qdb_calendar_entries",
                    ]);
                    if (extra_invalidate) {
                        queryClient.invalidateQueries(extra_invalidate);
                    }
                }, 3000);

                console.log("Mutation success, invalidating queries");
            },
            onError: (error) => {
                onError(error);
            },
        }
    );
};

export const sendPost = (endpoint, onSuccess, data, onDone = () => {}) => {
    return (
        (data) => {
            return botSecureAxios.post(`/${endpoint}`, data).then((res) => {
                return res?.data;
            });
        },
        {
            onSuccess: (data) => {
                onSuccess(data);
            },
        }
    );
};

export const checkEnoughTokens = (totalTokens, genTokens) => {
    if (totalTokens < genTokens) {
        return false;
    } else {
        return true;
    }
};

export const useReduceToken = (onSuccess, onDone = () => {}) => {
    return useMutation(
        (data) => {
            return botSecureAxios
                .post(`/gen/reduce_token`, data)
                .then((res) => {
                    return res?.data;
                });
        },
        {
            onSuccess: (result, variables, context) => {
                onSuccess(result);
                setTimeout(() => {
                    queryClient.invalidateQueries(["items", "qdb_token_plan"]);
                }, 2000);
            },
        }
    );
};
